export default __webpack_public_path__ + "static/media/chatBg-h5.faa044c4.png";